<template>
	<el-tooltip v-if="!noTip" effect="dark" :content="text" placement="top" popper-class="btn_tooltip">
		<div class="img_wrapper" :style="{background: bg, minWidth: width+'px', 'width': width+'px', 'height': height+'px', color}"
             @mouseover="mouseOver($event)"
             @mouseout="mouseOut($event)"
             @click="$emit('click', $event)">
			<cl-svg-icon v-if="iconClass && !isHover" :style="{'width': iconW+'px', 'height': iconH+'px'}" :icon-class="iconClass"></cl-svg-icon>
			<cl-svg-icon v-if="iconClass && isHover" :style="{'width': iconW+'px', 'height': iconH+'px'}" :icon-class="hoverIcon || iconClass"></cl-svg-icon>
			<img v-if="!iconClass" :style="{'width': iconW+'px', 'height': iconH+'px', }" :src="src"/>
		</div>
	</el-tooltip>
    <div v-else class="img_wrapper" :style="{background: bg, minWidth: width+'px', 'width': width+'px', 'height': height+'px', color}"
         @mouseover="mouseOver($event)"
         @mouseout="mouseOut($event)"
         @click="$emit('click', $event)">
        <cl-svg-icon v-if="iconClass && !isHover" :style="{'width': iconW+'px', 'height': iconH+'px'}" :icon-class="iconClass"></cl-svg-icon>
        <cl-svg-icon v-if="iconClass && isHover" :style="{'width': iconW+'px', 'height': iconH+'px'}" :icon-class="hoverIcon || iconClass"></cl-svg-icon>
        <img v-if="!iconClass" :style="{'width': iconW+'px', 'height': iconH+'px', }" :src="src"/>
    </div>
</template>

<script>
/**
 * ComponentName: report
 * Created Date:2022/4/28
 * Author: zhangch
 * Modify: 
 * 组件说明：
 * eg:
 *     <cl-tooltip-btn></cl-tooltip-btn>
 */
	export default {
        name: 'cl-tooltip-btn',
		props: {
			/* 图片路径 */
			src: {
				type: [String, Object],
				default: ''
			},
			// 组件宽度-默认34px
			width: {
				type: String | Number,
				default: '34'
			},
			// 组件高度-默认34px
			height: {
				type: String | Number,
				default: '34'
			},
			// 是否是svg图片
			iconClass: {
				type: String,
				default: ''
			},
            // hover状态的icon
            hoverIcon: {
                type: String,
                default: ''
            },
			/* 提示文字 */
			text: {
				type: String,
				default: ''
			},
			/* 按钮背景颜色 */
			bg: {
				type: String,
				default: '#796FF7'
			},
            /* hover时按钮背景颜色 */
			hoverBg: {
				type: String,
				default: ''
			},
			// img宽度
			iconW: {
				type: String | Number,
				default: '18'
			},
			// img高度
			iconH: {
				type: String | Number,
				default: '18'
			},
			// svg颜色
			color: {
				type: String,
				default: ''
			},
		},
		data() {
			return {
				description: '带有提示的图标按钮',
                isHover: false,
			}
		},
        computed: {
            noTip() {
                return this.text == '';
            },
        },
		mounted() {

		},
        methods: {
            mouseOver($event){
                this.isHover = true;
                $event.currentTarget.style.background = this.hoverBg || this.bg;
                $event.currentTarget.style.color = '#fff';
            },
            mouseOut($event){
                this.isHover = false;
                $event.currentTarget.style.background = this.bg;
                $event.currentTarget.style.color = this.color;
            },
        }
	}
</script>

<style lang='scss' scoped>
.img_wrapper {
    cursor: pointer;
	display: flex;
	justify-content: center;
	align-items: center;
	border-radius: $base-border-radius-mini;
}
.btn_tooltip /deep/ .el-tooltip__popper .popper__arrow::after {
    border-top-color: #303133 !important;
}
.btn_tooltip /deep/ .el-tooltip__popper .popper__arrow {
    border-top-color: #303133 !important;
}
</style>